<template>
<div class="container">
        <table class="table table-borded table-responsive table-striped rounded" id="table-list">
            <thead class="table-dark rounded">
                <tr>
                    <td>Nama(<small>Cabang</small>)</td>
                    <td>Kredit</td>
                    <td>Angsuran ke</td>
                    <td>Tempo</td>
                </tr>
            </thead>
            <tbody class="border-bottom rounded">
                <tr v-for="nasa in nasabah.data" :key="nasa.id">
                    <td><a href="#" @click="redirect(nasa.pinjaman_id)"> {{nasa.nama_nasabah}} ({{nasa.cabang_id}})</a></td>
                    <td>Rp.{{nasa.nominal | rupiah}}</td>
                    <td>{{nasa.angsuran}}</td>
                    <td>{{nasa.tempo}}</td>
                </tr>
            </tbody>

        <pagination :data="nasabah" @pagination-change-page="getResults">
        </pagination>
        </table>
    </div>


</template>
<style scoped>

  
    
</style>
<script>
// import the styles

export default {
   
  name: 'goodtable',
  data(){
    return {
      nasabah:{},
      
    };
  },
 async mounted(){
     await axios.get('api/nasabahyangbelumbayar').then((res)=>{

         this.nasabah = res.data

})
    //    await this.getResults();
.catch((e)=>{console.log(e)})

},methods:{
   // Our method to GET results from a Laravel endpoint
		getResults(page = 1) {
			axios.get('api/nasabahyangbelumbayar?page=' + page)
				.then(response => {
					this.nasabah = response.data;
				})
        },
        redirect(id){
window.location.href = `/customer/detail-pinjaman/${id}`;
        }
}
};
</script>